import { useState } from 'react';
import { Nav } from '../sections/Nav.js';
import { Hero } from '../sections/Hero.js';
import { Stats } from '../sections/Stats.js';
import { Service } from '../sections/Service.js';
import { Compare } from '../sections/Compare.js';
import { Technology } from '../sections/Technology.js';
import { Worker } from '../sections/Worker.js';
import { Closing } from '../sections/Closing.js';
import { Colophon } from '../sections/Colophon.js';
import { submitWaitlist, waitlistErrorCode, type WaitlistErrorCode } from '../api/waitlist.js';
import type { WashedLocale } from '@washed/i18n';

export type FormState =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'success'; position: number; alreadyListed: boolean }
  | { kind: 'error'; code: WaitlistErrorCode };

interface HomePageProps {
  locale?: WashedLocale;
  onLocaleChange?: (locale: WashedLocale) => void;
}

export function HomePage({ locale: localeProp, onLocaleChange }: HomePageProps = {}) {
  const [localeState, setLocaleState] = useState<WashedLocale>('fr');
  const locale = localeProp ?? localeState;
  const setLocale = onLocaleChange ?? setLocaleState;
  const [closingState, setClosingState] = useState<FormState>({ kind: 'idle' });

  const handleClosing = async (input: {
    phone: string;
    quartier?: string;
    email?: string;
    source: 'closing';
    consentTerms: boolean;
    cfTurnstileResponse?: string;
  }) => {
    setClosingState({ kind: 'loading' });
    try {
      const res = await submitWaitlist({ ...input, audience: 'subscriber', locale });
      setClosingState({
        kind: 'success',
        position: res.position,
        alreadyListed: res.alreadyListed,
      });
    } catch (e) {
      setClosingState({ kind: 'error', code: waitlistErrorCode(e) });
    }
  };

  return (
    <>
      <Nav locale={locale} onLocaleChange={setLocale} />
      <main id="contenu" tabIndex={-1} className="home-main">
        <Hero locale={locale} />
        <Stats locale={locale} variant="trust" />
        <Service locale={locale} />
        <Compare locale={locale} />
        <Technology locale={locale} />
        <Worker locale={locale} showForm={false} />
        <Closing locale={locale} onSubmit={handleClosing} state={closingState} />
      </main>
      <Colophon locale={locale} />
    </>
  );
}
